import { html, LitElement, css, unsafeCSS } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

import '../components/discorduser';

import style from './speedruns.scss';
import { isSunforge, isTouchDevice, loadURLParams, setTitle } from '../shared/utils';
import { trackPage } from '../shared/utils';
import { DATA_CLASSES } from '../data/sources';
import { DIFFICULTY } from '../shared/types';
export class SpeedRunsPage extends LitElement {

    static get properties() {
        return {
            runs: Object
        }
    }

    constructor() {
        super();
        this.runs = null;
        this.diff = '';
        this.class = '';
        this.top = '';
        this.options = '';
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        let params = {
            diff: '',
            class: '',
            top: '',
            options: ''
        };
        loadURLParams(params);
        this.diff = params.diff;
        this.class = params.class;     
        this.top = params.top;   
        this.options = params.options;
        setTitle('Speed Runs');
        this.fetchData();
    }

    async fetchData() {
        let res = await fetch(`./api/speedruns?diff=${this.diff}&class=${this.class}&top=${this.top}&options=${this.options}`);
        if (res.status === 200) {
            this.runs = await res.json();
        }
    }

    updateURL(){        
        if(window.history){                        
            window.history.replaceState(null, document.title, `./speedruns?diff=${this.diff}&class=${this.class}&top=${this.top}&options=${this.options}`);
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
    }

    renderDeck(deck,i) {        
        let artwork = 'cardart_5_50';
        if (deck.talents[0])
            artwork = deck.talents[0].artwork;
        if (deck.base[1])
            artwork = deck.base[1].artwork;
        return html`<div class="line">
            <div class="bubble big" style="${isTouchDevice() ? `position: absolute;
right: 75px;`: ''}">#${i+1}</div>
            <a class="class-${deck.class.replace('[', '').replace(']', '').toLowerCase()}" href="./deck/${deck.uid}"><div class="artwork" 
            style="background-image:url(./images/icons/${(artwork || '').replace(/ /g, '%20')}.webp);${isTouchDevice() ? `position: absolute;
right: 10px;`: ''}"></div> ${deck.name}${isTouchDevice() ? html`<br/>` : ' '}${isSunforge(deck.class) ? (isTouchDevice() ? 'Sunforge':'') : deck.class} <small>(${deck.bosses.length} bosses)</small></a> 
            ${deck.discorduser?html`
            ${isTouchDevice()?html`<br>`:html`&nbsp;&nbsp;`}
            <discorduser-component user=${deck.discorduser}></discorduser-component>
            `:''}
            <div style=${styleMap(!isTouchDevice() ? {
            'position': 'absolute',
            'right': '10px',
            'top': '15px',
            'text-align':'right',
            'font-weight': 'bold'      
        } : {})}>
                ${(deck.stats?.clock1 || '').replace(/\*/g, '').replace('Duration:', '🕐')}<br>                
            </div>
        </div>`;
    }

    render() {
        if (!this.runs)
            return html`Crunching the numbers....`;
        return html`
            <h1>Speed Runs</h1>
            <p>Note: This data is aggregated from submitted decks from Discord and Blightbane. Challenge runs are excluded.</p>
            <select @change=${(ev)=>{
                    this.diff = ev.target.value;        
                    this.updateURL();            
                    this.fetchData();
                }}>
                <option value="">-- Difficulty --</option>
                ${DIFFICULTY.map((val,i)=>{
                    if(val)
                        return html`<option value="${val}" ?selected=${this.diff === val}>${val}</option>`;
                })}
            </select>  
            <select @change=${(ev)=>{
                    this.class = ev.target.value;      
                    this.updateURL();              
                    this.fetchData();
                }}>
                <option value="">-- Class --</option>
                ${[...DATA_CLASSES,{name:'Sunforge',value:'Scion'}].map((val,i)=>{
                    if(val)
                        return html`<option value="${val.value || val.name}" ?selected=${this.class === (val.value || val.name)}>${val.name}</option>`;
                })}
            </select>   
            <select @change=${(ev)=>{
                    this.top = ev.target.value;      
                    this.updateURL();              
                    this.fetchData();
                }}>
                <option value="">-- Top --</option>
                ${[3,5,10,20].map((val)=>{                    
                    return html`<option value="${val}" ?selected=${+this.top === val}>Top ${val}</option>`;
                })}
            </select>   
            <select @change=${(ev)=>{
                    this.options = ev.target.value;      
                    this.updateURL();              
                    this.fetchData();
                }}>
                <option value="">-- Options --</option>
                ${[{opt:'unique',caption:'One run per Submitter'}].map((val)=>{                    
                    return html`<option value="${val.opt}" ?selected=${this.options === val.opt}>${val.caption}</option>`;
                })}
            </select>   
            ${Object.keys(this.runs[0]).map((cls) => {
                const hdr = cls.split('-');
                return html`            
                <h3>${isSunforge(hdr[0]) ? 'Sunforge' : `${hdr[0]} [${hdr[1]}]`} </h3>   
                ${this.runs[0][cls].map((d,i)=>html`
                    ${this.renderDeck(d,i)}
                `)}                                         
                `
        })}
        `;
    }
}

customElements.define('speedruns-page', SpeedRunsPage);